const Header = () => {
  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    if (targetId === 'home') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const element = document.getElementById(targetId);
      if (element) {
        const offset = 80; // Account for fixed header height
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
      }
    }
  };

  return (
    <nav className="w-full fixed top-0 z-50 backdrop-blur-sm bg-opacity-95" style={{ backgroundColor: '#111111' }}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex justify-between items-center">
          {/* Logo and RPS DIGITAL on Left */}
          <a href="#home" onClick={(e) => handleNavClick(e, 'home')} className="flex items-center gap-[9px]">
            <img src="/logo.png" alt="Logo" className="h-10 w-auto" />
            <h1 className="text-xl font-bold text-white tracking-tight" style={{ fontFamily: 'Montserrat, sans-serif' }}>RPS DIGITAL</h1>
          </a>
          {/* Navigation on Right */}
          <ul className="flex space-x-6 text-white">
            <li>
              <a 
                href="#home" 
                onClick={(e) => handleNavClick(e, 'home')}
                className="relative hover:text-purple-400 transition-colors font-medium group"
              >
                Home
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-purple-400 transition-all duration-300 group-hover:w-full"></span>
              </a>
            </li>
            <li>
              <a 
                href="#about" 
                onClick={(e) => handleNavClick(e, 'about')}
                className="relative hover:text-purple-400 transition-colors font-medium group"
              >
                About Us
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-purple-400 transition-all duration-300 group-hover:w-full"></span>
              </a>
            </li>
            <li>
              <a 
                href="#services" 
                onClick={(e) => handleNavClick(e, 'services')}
                className="relative hover:text-purple-400 transition-colors font-medium group"
              >
                Services
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-purple-400 transition-all duration-300 group-hover:w-full"></span>
              </a>
            </li>
            <li>
              <a 
                href="#contact" 
                onClick={(e) => handleNavClick(e, 'contact')}
                className="relative hover:text-purple-400 transition-colors font-medium group"
              >
                Contact
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-purple-400 transition-all duration-300 group-hover:w-full"></span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;

